import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { currentBrand } from '../../../utils/brand';

class Info extends Component {
  status = () => (
    <div className="col-12 col-sm-auto">
      {this.props.metaData.verificationLevel === 0 ? (
        <span className="badge badge-secondary text-uppercase ml-2">
          Not verified
        </span>
      ) : (
        <span className="badge badge-success text-uppercase ml-2">
          Verified
        </span>
      )}
    </div>
  );

  infoRow = (label, verificationLevel) => (
    <li>
      <i className="fas fa-check fa-xs text-success mr-2"></i>
      <FontAwesomeIcon
        icon={verificationLevel === 0 ? faTimes : faCheck}
        size="xs"
        color={verificationLevel === 0 ? 'red' : 'green'}
      />{' '}
      {label}
    </li>
  );

  mainInfoCol = () => (
    <div className="col-12 col-sm m-2 m-sm-0 m-md-0 ml-lg-3">
      <h6>Tier 1</h6>
      <small>
        Access to{' '}
        <a href={currentBrand().landingPageUrl}>{currentBrand().displayName}</a>
      </small>
      <div className="row mt-3">
        <div className="col-12">
          <p>This level requires the following:</p>
          <ul className="list-unstyled ml-3">
            {this.infoRow('Full Name', 1)}
            {this.infoRow('Passport number', 1)}
            {this.infoRow('Date of birth', 1)}
            {this.infoRow('Issuing country', 1)}
            {this.infoRow('Date of expiry', 1)}
            {this.infoRow(
              'Photo validation',
              this.props.metaData.verificationLevel,
            )}
          </ul>
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <div className="col-12 col-lg-6 order-3 order-lg-2">
        <div className="row py-3 my-2 px-0 mx-0 border rounded text-secondary ">
          {this.status()}
          {this.mainInfoCol()}
        </div>
      </div>
    );
  }
}

export default Info;
